import { ethers } from "ethers";
import {parseHash} from "./metadata";
import {getProbability} from "./elementData";
import {tokenBlacklist} from "./tokenBlackList";


import {get, readable, writable} from 'svelte/store';
import {
    provider,
    signer,
    address as myAddress,
    unlock,
    unlocked,
    onWalletChange,
    correct_network,
    wallet_injected, onUnlocked,
    target_mainnet
} from "./wallet.js";

// export let contractAddress = { //testnet
//     POWNFT: "0xa222cFb0b033bc8f04A9A78773bf85A7C4A27b17", //pownftplaceholder2
//     drops: "0xACC094951A7C8e0dedB8a47bAf4C4B55F1148Ae9",
// }

// export let contractAddress = { //ropsten
//     POWNFT: "0x5C13B394B325bD5199bF0BebFcCcdE36e7aF680E", //pownftplaceholder2
//     drops: "0xC97643Ae12Bf88EA65677c7f7198Bdf68f346B44",
// }

export let contractAddress = { //mainnet
    POWNFT: "0x9abb7bddc43fa67c76a62d8c016513827f59be1b",
    drops: "0xf24bc9c899e71708b5d076714408465b6c203a46",
}



//AtomReader: 0x2423Ad0de2419E48f2D3C28FE6674022D45bE6dc


// export let contractAddress = { //mainnet
//     pownft: "0x7D784062D87581ab942D35F3ab19e794ceb1a40a",
//     drops: "0x7D784062D87581ab942D35F3ab19e794ceb1a40a",
// }
// export let contractAddress = { //rinkeby
//     pownft: "0x7D784062D87581ab942D35F3ab19e794ceb1a40a",
//     drops: "0x7D784062D87581ab942D35F3ab19e794ceb1a40a",
// }

const MAINNET = {
    POWNFT: "0x7D784062D87581ab942D35F3ab19e794ceb1a40a",
    drops:  "0x7D784062D87581ab942D35F3ab19e794ceb1a40a",
}
const ZERO =    "0x0000000000000000000000000000000000000000";


// export let first_block = 8859000;
// export let first_block = 10666767;
// export let first_block = 0;
export let first_block = 13298992;

// export const correctAddress = contractAddress.drops === MAINNET.drops;
export const correctAddress = true;//

export const contractAbi = {
    POWNFT: ["event Approval(address indexed _owner,address indexed _approved,uint256 indexed _tokenId)","event ApprovalForAll(address indexed _owner,address indexed _operator,bool _approved)","event Migrate(uint256 indexed _tokenId)","event Mined(uint256 indexed _tokenId,bytes32 hash)","event Transfer(address indexed _from,address indexed _to,uint256 indexed _tokenId)","event Withdraw(uint256 indexed _tokenId,uint256 value)","function PREV_CHAIN_LAST_HASH() view returns(bytes32 )","function UNMIGRATED() view returns(uint256 )","function V2_TOTAL() view returns(uint256 )","function approve(address _approved,uint256 _tokenId) nonpayable","function balanceOf(address _owner) view returns(uint256 )","function getApproved(uint256 _tokenId) view returns(address )","function hashOf(uint256 _tokenId) view returns(bytes32 )","function isApprovedForAll(address _owner,address _operator) view returns(bool )","function migrate(uint256 _tokenId,uint256 _withdrawEthUntil) nonpayable","function migrateMultiple(uint256[] _tokenIds,uint256[] _withdrawUntil) nonpayable","function mine(uint256 nonce) payable","function name() view returns(string _name)","function ownerOf(uint256 _tokenId) view returns(address )","function safeTransferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes data) nonpayable","function setApprovalForAll(address _operator,bool _approved) nonpayable","function supportsInterface(bytes4 interfaceID) view returns(bool )","function symbol() view returns(string _symbol)","function tokenByIndex(uint256 _index) view returns(uint256 )","function tokenOfOwnerByIndex(address _owner,uint256 _index) view returns(uint256 )","function tokenURI(uint256 _tokenId) view returns(string )","function totalSupply() view returns(uint256 )","function transferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function withdraw(uint256 _tokenId,uint256 _withdrawUntil) nonpayable","function withdrawMultiple(uint256[] _tokenIds,uint256[] _withdrawUntil) nonpayable"],
    drops:  [
        "event ClaimDrop(address indexed tokenAddress, uint dropTokenId,uint tokenId, address indexed claimer)",
        "event RegisterDrop(address indexed tokenAddress, uint dropTokenId, uint atomicNumber, int8 ionCharge, bool isIon, uint tokenId, uint blockNumber)",
        "event CleanupDrop(address indexed tokenAddress, uint dropTokenId)",

        "function claimDrop(address tokenAddress, uint dropTokenId, uint tokenId) nonpayable",
        "function getDrop(address tokenAddress, uint dropTokenId) view returns(uint8 atomicNumber, int8 ionCharge, uint minTokenId, bool isIon)",
        "function registerDrop(address tokenAddress, uint dropTokenId, uint atomicNumber, int8 ionCharge, bool isIon, uint tokenId) nonpayable",
    ],
    ERC721:  ["event Approval(address indexed _owner,address indexed _approved,uint256 indexed _tokenId)","event ApprovalForAll(address indexed _owner,address indexed _operator,bool _approved)","event Transfer(address indexed _from,address indexed _to,uint256 indexed _tokenId)","function approve(address _approved,uint256 _tokenId) nonpayable","function balanceOf(address _owner) view returns(uint256 )","function getApproved(uint256 _tokenId) view returns(address )","function isApprovedForAll(address _owner,address _operator) view returns(bool )","function name() view returns(string _name)","function ownerOf(uint256 _tokenId) view returns(address )","function safeTransferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes data) nonpayable","function setApprovalForAll(address _operator,bool _approved) nonpayable","function supportsInterface(bytes4 interfaceID) view returns(bool )","function symbol() view returns(string _symbol)","function tokenByIndex(uint256 _index) view returns(uint256 )","function tokenOfOwnerByIndex(address _owner,uint256 _index) view returns(uint256 )","function tokenURI(uint256 _tokenId) view returns(string )","function totalSupply() view returns(uint256 )","function transferFrom(address _from,address _to,uint256 _tokenId) nonpayable"]
}


let contract = {
    POWNFT: null,
    drops:  null,
}
let contractWithSigner = {
    POWNFT: null,
    drops:  null,
}
export let me;

const BN = ethers.BigNumber;

export let state = writable('initial'); //initial, loading, loaded, network, error

export function cleanAddress(address){
    return String(address).toLowerCase();
}


export let _highestId = 0;
export let highestId = writable(_highestId);

export let _drops = {
    //address: {
    //  id: {
    //      atomicNumber:   0,
    //      ionCharge:      0,
    //      isIon:          false,
    //      tokenId:        0,
    //      blockNumber:    0,
    //      probability:    0,
    //  }
    //}
};
export let drops = writable(_drops);

export let _claimables = {
    // address: {
    //     id: [pownft tokenIds]
    // }
}
export let claimables = writable(_claimables);

let _toClaim = {
    //address: {
    //     dropTokenId:
    //          tokenId,
    //          claimer

};

export let _pastDrops = [];
    //  {
    //      tokenAddress,
    //      dropTokenId,
    //      atomicNumber: drop.atomicNumber,
    //      ionCharge: drop.ionCharge,
    //      isIon: drop.isIon,
    //      tokenId: drop.tokenId,
    //      blockNumber: drop.blockNumber,
    //  }

export let pastDrops = writable(_pastDrops);
let pastDropsLength = 20;

export let _myAtoms = {
    //tokenId: {
    //  hash: null, "0x1234",
    //  atomicNumber:   0,
    //  ionCharge:      0,
    //}
};
export let myAtoms = writable(_myAtoms);


export let _approvals = {
    // 0xaddress: "pending",true
};
export let approvals = writable(_approvals);

export let _tokenMetadata = {
    // address: {
    //  name: "",
    //  symbol: "",
    //  tokens: {
    //      id: {
    //          state: pending, loaded, fail
    //          uri: "https://www."
    //          name: "token name"
    //          description: "token description"
    //          image: "https://www."
    //      }
    //  }
    // }
}
export let tokenMetadata = writable(_tokenMetadata);

let dropContractMetadataQueue = []; //chain
let dropTokenMetadataQueue = []; //chain

const transactions = {
    // hash:{
    //     status: "pending",
    //     func: "purchase", //purchase
    //     params: {},
    // }
}
export let loader_i = writable(0);
export let loader_max = writable(1);

export let _pending = {
    registerDrop:       [],    //[hash(tokenAddress,dropTokenId)]
    claimDrop:          [],    //[hash(tokenAddress,dropTokenId)]
    setApprovalForAll:  [],    //[address]
}
export let pending = writable(_pending);
export let _requested = {
    registerDrop:       [],    //[hash(tokenAddress,dropTokenId)]
    claimDrop:          [],    //[hash(tokenAddress,dropTokenId)]
    setApprovalForAll:  [],    //[address]
}
export let requested = writable(_requested);

const parsed_events = {};

const callbacks = {
    RegisterDrop:   [],
    ClaimDrop:      [],
    CleanupDrop:      [],
    ApprovalForAll: [],
    Transfer:       [],

    transaction: {
        Submit: [],
        Confirm: [],
        Fail: [],
        Cancel: [],
    },
}

let blockNumbers = [];
function registerBlockNumber(blockNumber){
    // if(!event) return;
    // let blockNumber = Number(event.args.blockNumber._hex);
    blockNumbers.push(blockNumber);

    blockNumbers.sort((a,b)=>{return a<b?-1:1});
}
function clearBlockNumber(blockNumber){
    blockNumbers.splice(blockNumbers.indexOf(blockNumber),1);
}
export function dropHash(tokenAddress,dropTokenId){
    let id = parseInt(dropTokenId).toString(16);
    if(id.length %2 !== 0){ id = "0"+id};
    return ethers.utils.keccak256(
        cleanAddress(tokenAddress)+id
    );
}

async function getHighestId(){
    let supply = await contract.POWNFT.totalSupply();
    let unmigrated = await contract.POWNFT.UNMIGRATED();
    _highestId = parseInt(supply) + parseInt(unmigrated);
    highestId.set(_highestId);
}
function incrementHighestId(){
    _highestId++;
    highestId.set(_highestId);
}


let unchecked = {
    atoms: [],  //tokenId
    drops: [],  //"tokenAddress,id"
}
function checkClaimValidity(){
    while(unchecked.atoms.length > 0){
        let tokenId = unchecked.atoms.splice(0,1)[0];
        checkAtomValidity(tokenId);
    }
    while(unchecked.drops.length > 0){
        let l = (unchecked.drops.splice(0,1))[0].split(",");
        let dropTokenAddress = l[0];
        let dropTokenId = l[1];
        checkDropValidity(dropTokenAddress,dropTokenId);
    }
}

function checkAtomValidity(tokenId){
    for(let dropTokenAddress in _drops){
        for(let dropTokenId in _drops[dropTokenAddress]){
            if(isValidAtomForDrop(tokenId,_drops[dropTokenAddress][dropTokenId])){
                addClaimable(dropTokenAddress,dropTokenId,tokenId);
            }
        }
    }
}
function checkDropValidity(dropTokenAddress,dropTokenId){
    for(let tokenId in _myAtoms){
        if(isValidAtomForDrop(tokenId,_drops[dropTokenAddress][dropTokenId])){
            addClaimable(dropTokenAddress,dropTokenId,tokenId);
        }
    }
}
function isValidAtomForDrop(tokenId,drop){

    if(!_myAtoms[tokenId].hash || drop.tokenId === 0) return false;
    if(drop.isIon){
        return _myAtoms[tokenId].ionCharge !== 0;
    }else if(drop.atomicNumber > 0 && drop.ionCharge !== 0){
        return (
            _myAtoms[tokenId].atomicNumber === drop.atomicNumber
                &&
            _myAtoms[tokenId].ionCharge === drop.ionCharge
        );
    }else if(drop.atomicNumber > 0){
        return _myAtoms[tokenId].atomicNumber === drop.atomicNumber;
    }else if(drop.ionCharge !== 0){
        return _myAtoms[tokenId].ionCharge === drop.ionCharge;
    }else{
        //tokenId
        return parseInt(tokenId) >= drop.tokenId;
    }
}
function addClaimable(dropTokenAddress,dropTokenId,tokenId){
    if(!_claimables[dropTokenAddress]){
        _claimables[dropTokenAddress] = {

        }
    }
    if(!_claimables[dropTokenAddress][dropTokenId]){
        _claimables[dropTokenAddress][dropTokenId] = [];
    }
    _claimables[dropTokenAddress][dropTokenId].push(tokenId);
    claimables.set(_claimables);
}
function addAtomValidityCheck(tokenId){
    unchecked.atoms.push(parseInt(tokenId));
}
function addDropValidityCheck(tokenAddress,tokenId){
    unchecked.drops.push(cleanAddress(tokenAddress)+","+tokenId);
}


export function onRegisterDrop(callback){
    callbacks.RegisterDrop.push(callback);
}
export function onClaimDrop(callback){
    callbacks.ClaimDrop.push(callback);
}
export function onCleanupDrop(callback){
    callbacks.ClaimDrop.push(callback);
}

export function onTransfer(callback){
    callbacks.Transfer.push(callback);
}


export function onTransactionSubmit(callback){
    callbacks.transaction.Submit.push(callback);
}
export function onTransactionConfirm(callback){
    callbacks.transaction.Confirm.push(callback);
}
export function onTransactionFail(callback){
    callbacks.transaction.Fail.push(callback);
}
export function onTransactionCancel(callback){
    callbacks.transaction.Cancel.push(callback);
}

function transactionSubmitted(func,params){
    for(let i = 0; i < callbacks.transaction.Submit.length; i++){
        callbacks.transaction.Submit[i](func,params);
    }
}
function transactionConfirmed(func,params){
    for(let i = 0; i < callbacks.transaction.Confirm.length; i++){
        callbacks.transaction.Confirm[i](func,params);
    }
}
function transactionFailed(func,params){
    for(let i = 0; i < callbacks.transaction.Fail.length; i++){
        callbacks.transaction.Fail[i](func,params);
    }
}
function transactionCancelled(func,params){
    for(let i = 0; i < callbacks.transaction.Cancel.length; i++){
        callbacks.transaction.Cancel[i](func,params);
    }
}


function DropRegistered(tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId){
    for(let i = 0; i < callbacks.RegisterDrop.length; i++){
        callbacks.RegisterDrop[i](tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId);
    }
}
function DropClaimed(tokenAddress, dropTokenId,tokenId, claimer){
    for(let i = 0; i < callbacks.ClaimDrop.length; i++){
        callbacks.ClaimDrop[i](tokenAddress, dropTokenId,tokenId, claimer);
    }
}
function DropCleanup(tokenAddress, dropTokenId){
    for(let i = 0; i < callbacks.CleanupDrop.length; i++){
        callbacks.CleanupDrop[i](tokenAddress, dropTokenId);
    }
}
function Transferred(_from,_to,_tokenId){
    for(let i = 0; i < callbacks.Transfer.length; i++){
        callbacks.Transfer[i](_from,_to,_tokenId);
    }
}



function parse_Transfer(_from,_to,_tokenId){
    if(_from === me){
        delete _myAtoms[_tokenId];
    }
    if(_to === me){
        _myAtoms[_tokenId] = {
            hash: null,
        };
        // addAtomValidityCheck(_tokenId);
        requestMetadata(_tokenId);
    }
    myAtoms.set(_myAtoms);

    if(get(state) === "loaded"){
        incrementHighestId();
    }

    Transferred(_from,_to,_tokenId);
}
function parse_RegisterDrop(tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId, blockNumber){
    if(tokenBlacklist.includes(tokenAddress)) return;

    // console.log(tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId, blockNumber);

    if(!_drops[tokenAddress]){
        _drops[tokenAddress] = {};
    }
    _drops[tokenAddress][dropTokenId] = {
         atomicNumber,
         ionCharge,
         isIon,
         tokenId,
         blockNumber,
        probability: getProbability(atomicNumber, ionCharge, isIon, tokenId),
     }
    drops.set(_drops);

    addDropValidityCheck(tokenAddress,dropTokenId);

    if(get(state) === "loaded"){
        requestDropContractMetadata(tokenAddress);
        requestDropTokenMetadata(tokenAddress,dropTokenId);
        checkClaimValidity();
    }

    registerBlockNumber(blockNumber);

    DropRegistered(tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId);
}
function parse_ClaimDrop(tokenAddress, dropTokenId,tokenId, claimer){
    if(tokenBlacklist.includes(tokenAddress)) return;

    if(!_drops[tokenAddress] || !_drops[tokenAddress][dropTokenId]) {
        if(!_toClaim[tokenAddress]){
            _toClaim[tokenAddress] = {};
            _toClaim[tokenAddress][dropTokenId] = {
                tokenId,
                claimer
            }
        }
        return;
    }




    let drop = _drops[tokenAddress][dropTokenId];

    _pastDrops.splice(0,0,{
        tokenAddress,
        dropTokenId,
        atomicNumber: drop.atomicNumber,
        ionCharge: drop.ionCharge,
        isIon: drop.isIon,
        tokenId: drop.tokenId,
        blockNumber: drop.blockNumber,
    });
    if(_pastDrops.length > pastDropsLength){
        _pastDrops.pop();
    }
    pastDrops.set(_pastDrops);

    if(_claimables[tokenAddress] && _claimables[tokenAddress][dropTokenId]){
        delete _claimables[tokenAddress][dropTokenId];
        claimables.set(_claimables);
    }


    delete _drops[tokenAddress][dropTokenId];
    drops.set(_drops);

    clearBlockNumber(drop.blockNumber);

    DropClaimed(tokenAddress, dropTokenId,tokenId, claimer);
}
function parse_CleanupDrop(tokenAddress, dropTokenId){
    if(tokenBlacklist.includes(tokenAddress)) return;

    let drop = _drops[tokenAddress][dropTokenId];

    // _pastDrops.splice(0,0,{
    //     tokenAddress,
    //     dropTokenId,
    //     atomicNumber: drop.atomicNumber,
    //     ionCharge: drop.ionCharge,
    //     isIon: drop.isIon,
    //     tokenId: drop.tokenId,
    //     blockNumber: drop.blockNumber,
    // });
    // if(_pastDrops.length > pastDropsLength){
    //     _pastDrops.pop();
    // }
    // pastDrops.set(_pastDrops);

    if(_claimables[tokenAddress] && _claimables[tokenAddress][dropTokenId]){
        delete _claimables[tokenAddress][dropTokenId];
        claimables.set(_claimables);
    }


    delete _drops[tokenAddress][dropTokenId];
    drops.set(_drops);

    clearBlockNumber(drop.blockNumber);

    DropCleanup(tokenAddress, dropTokenId);
}



function clear_transaction(hash){
    if(!transactions[hash]) return;
    const func = transactions[hash].func;
    const params = transactions[hash].params;

    switch (func){
        case "registerDrop":
        case "claimDrop":
            let idHash = dropHash(
                params.tokenAddress,
                params.dropTokenId
            );
            _pending[func][idHash] = false;
            break;
    }
    delete transactions[hash];
    pending.set(_pending);
    transactionConfirmed(func,params);
}

//
// let dropRegisterTxCallbacks = [];
// export function onRegisterDropTx(func){
//     dropRegisterTxCallbacks.push(func);
// }
// function dropRegisteredTx(params){
//     for(let i = 0; i < dropRegisterTxCallbacks.length; i++){
//         dropRegisterTxCallbacks[i](params);
//     }
// }


function parse_event(event){
    if(typeof event === "undefined") {
        return;
    }

    const index = event.logIndex+event.transactionHash.substr(1,12);

    if(parsed_events[index]) {
        return;
    }
    parsed_events[index] = true;

    if(transactions[event.transactionHash]){
        clear_transaction(event.transactionHash);
    }

    switch (event.event){
        case "Transfer":
            parse_Transfer(
                cleanAddress(event.args._from),
                cleanAddress(event.args._to),
                Number(event.args._tokenId._hex)
            );
            break;
        case "RegisterDrop":
            //tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId
            // console.log(event);
            parse_RegisterDrop(
                cleanAddress(event.args.tokenAddress),
                Number(event.args.dropTokenId._hex),
                Number(event.args.atomicNumber._hex),
                Number(event.args.ionCharge),
                Boolean(event.args.isIon),
                Number(event.args.tokenId._hex),
                Number(event.args.blockNumber._hex),
            );
            break;
        case "ClaimDrop":
            //tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId
            parse_ClaimDrop(
                cleanAddress(event.args.tokenAddress),
                Number(event.args.dropTokenId._hex),
                Number(event.args.tokenId._hex),
                cleanAddress(event.args.claimer)
            );
            break;
        case "CleanupDrop":
            //tokenAddress, dropTokenId
            parse_CleanupDrop(
                cleanAddress(event.args.tokenAddress),
                Number(event.args.dropTokenId._hex)
            );
            break;
        default:
            // console.log("Other event:",event.event);

            break
    }
}
export async function connect(){
    state.set('loading');

    contract.POWNFT = new ethers.Contract(contractAddress.POWNFT,contractAbi.POWNFT,provider);
    contract.drops  = new ethers.Contract(contractAddress.drops,contractAbi.drops,provider);

    contractWithSigner.POWNFT = contract.POWNFT.connect(signer);
    contractWithSigner.drops  = contract.drops.connect(signer);

    me = cleanAddress(get(myAddress));

    await getHighestId();

    await processPastEvents();

    triggerInitialMetadata();
    checkClaimValidity();

    // console.log(_myAtoms);

    // await log_data();

    console.log('connect contract events');

    contractWithSigner.POWNFT.on( "Transfer" , (a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20)=>{
        let event;
        //default arguments variable isnt workin for some reason. this will do
        let args = [a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20];

        for(let a = 0; a < args.length; a++) {
            if (typeof args[a] === "object"
                && args[a].event === "Transfer") {
                event = args[a];
                break;
            }
        }
        if(!event) return;
        parse_event(event);
    } );
    contractWithSigner.drops.on( "RegisterDrop" , (a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20)=>{
        let event;
        //default arguments variable isnt workin for some reason. this will do
        let args = [a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20];

        for(let a = 0; a < args.length; a++) {
            if (typeof args[a] === "object"
                && args[a].event === "RegisterDrop") {
                event = args[a];
                break;
            }
        }
        if(!event){
            console.log("!no event");
            return;
        }
        parse_event(event);
    } );
    contractWithSigner.drops.on( "ClaimDrop" , (a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20)=>{
        let event;
        //default arguments variable isnt workin for some reason. this will do
        let args = [a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20];

        for(let a = 0; a < args.length; a++) {
            if (typeof args[a] === "object"
                && args[a].event === "ClaimDrop") {
                event = args[a];
                break;
            }
        }
        if(!event) return;
        parse_event(event);
    } );
    contractWithSigner.drops.on( "CleanupDrop" , (a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20)=>{
        let event;
        //default arguments variable isnt workin for some reason. this will do
        let args = [a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20];

        for(let a = 0; a < args.length; a++) {
            if (typeof args[a] === "object"
                && args[a].event === "CleanupDrop") {
                event = args[a];
                break;
            }
        }
        if(!event) return;
        parse_event(event);
    } );

    // console.log(contractWithSigner.listeners("RegisterDrop"));

    state.set('loaded');
}

function reset(){
    console.log("injetcted reset")


    _pending = {
        registerDrop: [],    //[hash(tokenAddress,dropTokenId)]
        claimDrop: [],       //[hash(tokenAddress,dropTokenId)]
    }
    pending.set(_pending);

    _requested = {
        registerDrop: [],    //[hash(tokenAddress,dropTokenId)]
        claimDrop: [],       //[hash(tokenAddress,dropTokenId)]
    }
    requested.set(_requested);

    _toClaim = {};

    _drops = {};
    drops.set(_drops);

    _claimables = {};
    claimables.set(_claimables);

    _pastDrops = [];
    pastDrops.set(_pastDrops);

    _myAtoms = {};
    myAtoms.set(_myAtoms);

    _approvals = {};
    approvals.set(_approvals);

    _tokenMetadata = {};
    tokenMetadata.set(_tokenMetadata);

    dropContractMetadataQueue = [];
    dropTokenMetadataQueue = [];
    blockNumbers = [];

    for(let tx in transactions){
        delete transactions[tx];
    }

    for(let evt in parsed_events){
        delete parsed_events[evt];
    }
}

async function processPastEvents(){
    console.log("injected: process past events")
    if(!contractWithSigner.POWNFT) return;


    let current_block = await provider.getBlockNumber();

    loader_max.set(current_block - first_block);

    // console.log(current_block);

    // const interval = 50000;
    const interval = 500000;
    // const interval = 10000;

    let pownft_filter1 = contractWithSigner.POWNFT.filters.Transfer();
    let drops_filter1  = contractWithSigner.drops.filters.RegisterDrop();
    let drops_filter2  = contractWithSigner.drops.filters.ClaimDrop();

    ///5000
    //0
    // console.log('load events:');
    let processed = [];

    // let blockNumber = 0;


    if(correctAddress){
        console.log('first_block:',first_block);
        for(let i = first_block; i < current_block - interval; i += interval){
            loader_i.set(i - first_block + interval);

            let all = await contractWithSigner.drops.queryFilter(
                [drops_filter1,
                    drops_filter2
                ],
                i,
                i + (interval - 1)
            );

            all.forEach(evt => {
                parse_event(evt);
            });
        }
        let all = await contractWithSigner.drops.queryFilter(
            [drops_filter1,
                drops_filter2
            ],
            current_block - interval,
        );
        all.forEach(evt => {
            parse_event(evt);
        });

    }else{
        let all = await contractWithSigner.drops.queryFilter(
            [drops_filter1,
                drops_filter2,
                // filter3,
                // filter4
            ]
        );
        all.forEach(evt => {
            parse_event(evt);
        });
    }

    if(blockNumbers.length > 0){
        let pownft_first_block = blockNumbers[0];

        for(let i = pownft_first_block; i < current_block - interval; i += interval){
            // loader_i.set(i - first_block + interval);

            let all = await contractWithSigner.POWNFT.queryFilter(
                [pownft_filter1],
                i,
                i + (interval - 1)
            );

            all.forEach(evt => {
                parse_event(evt);
            });
        }
        let all = await contractWithSigner.POWNFT.queryFilter(
            [pownft_filter1],
            current_block - interval,
        );
        all.forEach(evt => {
            parse_event(evt);
        });
    }



}


///Function

function cancel_transaction(func,params){
    switch (func){
        case "registerDrop":
        case "claimDrop":
            let idHash = dropHash(
                params.tokenAddress,
                params.dropTokenId
            );
            // let idHash = ethers.utils.keccak256([
            //     params.tokenAddress,
            //     params.dropTokenId
            // ]);
            delete _requested[func][idHash];
            break;
    }
    requested.set(_requested);

    transactionCancelled(func,params);
}
function request_transaction(func,params){
    switch (func){
        case "registerDrop":
        case "claimDrop":
            // let idHash = ethers.utils.keccak256([
            //     params.tokenAddress,
            //     params.dropTokenId
            // ]);
            let idHash = dropHash(
                params.tokenAddress,
                params.dropTokenId
            );
            _requested[func][idHash] = true;
            break;
    }
    requested.set(_requested);
}
function register_transaction(tx,func,params){
    transactions[tx.hash] = {
        status: "pending",
        func: func,
        params: params,
    }
    switch (func){
        case "registerDrop":
        case "claimDrop":
            // let idHash = ethers.utils.keccak256([
            //     params.tokenAddress,
            //     params.dropTokenId
            // ]);
            let idHash = dropHash(
                params.tokenAddress,
                params.dropTokenId
            );
            _pending[func][idHash] = true;
            delete _requested[func][idHash];
            break;
    }

    pending.set(_pending);
    requested.set(_requested);

    transactionSubmitted(func,params);

    await_failure(tx.hash);
}

const await_failure = async(hash) => {
    const failure = (await provider.waitForTransaction( hash )).status === 0;
    if(failure){
        fail_transaction(hash);
    }
}

function fail_transaction(hash){
    if(!transactions[hash]) return;
    transactionFailed(transactions[hash].func,transactions[hash].params);
    // transactions[hash].status = "failed";

    const func = transactions[hash].func;
    const params = transactions[hash].params;
    switch (func){
        case "registerDrop":
        case "claimDrop":
            // let idHash = ethers.utils.keccak256([
            //     params.tokenAddress,
            //     params.dropTokenId
            // ]);
            let idHash = dropHash(
                params.tokenAddress,
                params.dropTokenId
            );
            _pending[func][idHash] = false;
            break;
    }


    delete transactions[hash];
    pending.set(_pending);
}


function alert_error(e){
    switch(e.code){
        case 4001:
            ///cancel
            break;
        //TODO: default?
        case "INSUFFICIENT_FUNDS":
            alert("You don't have enough ETH to make this transaction");
            break;
        default:
            if(e.message.includes("execution reverted: difficulty")){
                alert("Error: Your mining result is no longer valid and your transaction will fail.");
            }else{
                alert("Metamask error: "+e.message);

            }
            break;

    }
}


//Drops
export async function registerDrop(tokenAddress, dropTokenId, atomicNumber, ionCharge, isIon, tokenId){
    let hash = dropHash(tokenAddress,dropTokenId);
    if(_requested.registerDrop[hash] || _pending.registerDrop[hash]) return;

    request_transaction('registerDrop',{
        tokenAddress,
        dropTokenId,
        atomicNumber,
        ionCharge,
        isIon,
        tokenId
    });
    try{
        const tx =  await contractWithSigner.drops.registerDrop(tokenAddress,
            dropTokenId,
            atomicNumber,
            ionCharge,
            isIon,
            tokenId);

        register_transaction(tx,'registerDrop', {
            tokenAddress,
            dropTokenId,
            atomicNumber,
            ionCharge,
            isIon,
            tokenId
        });

        await tx.wait();


    }catch(e){
        cancel_transaction('registerDrop', {tokenAddress,
            dropTokenId,
            atomicNumber,
            ionCharge,
            isIon,
            tokenId});

        alert_error(e);
        return false;
    }
}
export async function claimDrop(tokenAddress, dropTokenId, tokenId){
    let hash = dropHash(tokenAddress,dropTokenId);
    if(_requested.claimDrop[hash] || _pending.claimDrop[hash]) return;

    request_transaction('claimDrop',{
        tokenAddress, dropTokenId, tokenId
    });
    try{
        const tx =  await contractWithSigner.drops.claimDrop(tokenAddress, dropTokenId, tokenId);

        register_transaction(tx,'claimDrop', {
            tokenAddress, dropTokenId, tokenId
        });

    }catch(e){
        cancel_transaction('claimDrop', {
            tokenAddress, dropTokenId, tokenId
        });

        alert_error(e);
        return false;
    }
}
export async function getDrop(tokenAddress, dropTokenId){
    return await contract.drops.getDrop(tokenAddress, dropTokenId);
}

//POWNFT
export async function hashOf(_tokenId){
    return await contract.POWNFT.hashOf(_tokenId);
}
let metadataQueue = [];
export async function requestMetadata(tokenId){
    metadataQueue.push(tokenId);
    if(metadataQueue.length === 1){
        await fetchTokenMetadata();
    }
}

export async function fetchTokenMetadata(){
    if(metadataQueue.length === 0) return;
    let tokenId = metadataQueue[0];

    try{
        let hash = await hashOf(tokenId);
        let metadata = parseHash(tokenId,hash);

        if(_myAtoms[tokenId]){
            _myAtoms[tokenId].hash = hash;
            _myAtoms[tokenId].atomicNumber = metadata.atomicNumber;
            _myAtoms[tokenId].ionCharge = metadata.ion_charge;
        }
        myAtoms.set(_myAtoms);
        metadataQueue.splice(0,1);
        addAtomValidityCheck(tokenId);
        checkClaimValidity();

        fetchTokenMetadata();
    }catch(e){
        //Note, will lose fetchTokenMetadata loop if it fails
        // and not restart automatically
        console.log(e);
    }


}


//External
export async function isApprovedForAll(tokenAddress){
    let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
    try{
        return Boolean(await contract.isApprovedForAll(me,contractAddress.drops));
    }catch(e){
        alert_error(e);
        return false;
    }
}
export async function getApproval(tokenAddress){
    let approved = "checking";
    if(!_approvals[tokenAddress]){
        approved = "checking";
        approved = await isApprovedForAll(tokenAddress);
        if(approved){
            _approvals[tokenAddress] = true;
        }else{
            _approvals[tokenAddress] = "false";
        }
        approvals.set(_approvals);
    }else if(_approvals[tokenAddress] !== "pending"){
        approved = true;
    }
    return approved;
}
export async function setApprovalForAll(tokenAddress){
    let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
    let contractWithSigner = contract.connect(signer);

    try{
        _approvals[tokenAddress] = "pending";
        approvals.set(_approvals);
        const transaction =  await contractWithSigner.setApprovalForAll(contractAddress.drops,true);
        await transaction.wait();
        _approvals[tokenAddress] = true;
    }catch(e){
        alert_error(e);
        _approvals[tokenAddress] = "false";
    }
    approvals.set(_approvals);
}

export function isValidAddress(address){
    try{
        address = ethers.utils.getAddress(address);
    }catch(e){
        return false;
    }
    return true;
}

export async function isValidToken(tokenAddress){
    if(!isValidAddress(tokenAddress)) return false;

    try{
        let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
        let ERC721interfaceId = "0x80ac58cd";
        let valid = await contract.supportsInterface(ERC721interfaceId);

        return Boolean(valid);
    }catch(e){
        return false;
    }
}
export async function amOwner(tokenAddress, tokenId){
    try{
        let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
        // let ERC721interfaceId = "0x80ac58cd";
        let owner = await contract.ownerOf(tokenId);
        return (cleanAddress(owner) === cleanAddress(me));
    }catch(e){
        return false;
    }
}

function queueDropContractMetadata(tokenAddress){
    tokenAddress = cleanAddress(tokenAddress);
    if(!_tokenMetadata[tokenAddress] && !dropContractMetadataQueue.includes(tokenAddress)) {
        _tokenMetadata[tokenAddress] = {
            name: "",
            symbol: "",
            tokens: {}
        }
        dropContractMetadataQueue.splice(1, 0, tokenAddress);
        return true;
    }
    return false;
}
function queueDropTokenMetadata(tokenAddress,tokenId){
    tokenAddress = cleanAddress(tokenAddress);
    tokenId = parseInt(tokenId);
    let queueId = JSON.stringify([tokenAddress,tokenId]);

    if(
        (!_tokenMetadata[tokenAddress] || !_tokenMetadata[tokenAddress].tokens[tokenId])
        &&
        !dropTokenMetadataQueue.includes(queueId)
    ) {
        dropTokenMetadataQueue.splice(1, 0, queueId);
        return true;
    }
    return false;

}

export async function requestDropContractMetadata(tokenAddress){
    // console.log("request drop contract metadata:",tokenAddress)

    if(queueDropContractMetadata(tokenAddress)){
        if(dropContractMetadataQueue.length === 1){
            fetchDropContractMetadata();
        }
    }
    // tokenAddress = cleanAddress(tokenAddress);
    // if(!_tokenMetadata[tokenAddress] && !dropContractMetadataQueue.includes(tokenAddress)){
    //     dropContractMetadataQueue.splice(1,0,tokenAddress);
    //     if(dropContractMetadataQueue.length === 1){
    //         fetchDropContractMetadata();
    //     }
    // }
}
export async function requestDropTokenMetadata(tokenAddress,tokenId) {
    if(queueDropTokenMetadata(tokenAddress,tokenId)){
        if(dropTokenMetadataQueue.length === 1){
            fetchDropTokenMetadata();
        }
    }

    // tokenAddress = cleanAddress(tokenAddress);
    // tokenId = parseInt(tokenId);
    // let queueId = JSON.stringify([tokenAddress,tokenId]);
    //
    // if(
    //     (!_tokenMetadata[tokenAddress] || !_tokenMetadata[tokenAddress].tokens[tokenId])
    //         &&
    //     !dropTokenMetadataQueue.includes(queueId)
    // ){
    //     dropTokenMetadataQueue.splice(1,0,queueId);
    //     if(dropTokenMetadataQueue.length === 1){
    //         fetchDropTokenMetadata();
    //     }
    // }


}

async function fetchDropContractMetadata(){
    if(dropContractMetadataQueue.length === 0) return;

    let tokenAddress = cleanAddress(dropContractMetadataQueue[0]);
    if(!_tokenMetadata[tokenAddress]){
        _tokenMetadata[tokenAddress] = {
            name: "",
            symbol: "",
            tokens: {}
        };

    }
    tokenMetadata.set(_tokenMetadata);

    let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
    try{
        _tokenMetadata[tokenAddress].name = await contract.name();
        tokenMetadata.set(_tokenMetadata);
    }catch(e){

    }
    try{
        _tokenMetadata[tokenAddress].symbol = await contract.symbol();
        tokenMetadata.set(_tokenMetadata);
    }catch(e){

    }

    //Splice at the end because length is used to indicate readiness

    //Check in case of data resets
    if(cleanAddress(dropContractMetadataQueue[0]) === tokenAddress){
        dropContractMetadataQueue.splice(0,1);
        fetchDropContractMetadata();
    }


}
async function fetchDropTokenMetadata(){
    if(dropTokenMetadataQueue.length === 0) return;

    let queueItem = dropTokenMetadataQueue[0];
    let queueData = JSON.parse(queueItem);

    let tokenAddress = cleanAddress(queueData[0]);
    let tokenId = parseInt(queueData[1]);


    if(!_tokenMetadata[tokenAddress]){
        await requestDropContractMetadata(tokenAddress);
        // _tokenMetadata[tokenAddress] = {
        //     name: "",
        //     symbol: "",
        //     tokens: {
        //
        //     }
        // };
    }
    _tokenMetadata[tokenAddress].tokens[tokenId] = {
        state: "pending",
        uri: "",
        name: "",
        description: "",
        image: "",
    }
    tokenMetadata.set(_tokenMetadata);


    let contract = new ethers.Contract(tokenAddress, contractAbi.ERC721, provider);
    try{
        let uri = await contract.tokenURI(tokenId);
        _tokenMetadata[tokenAddress].tokens[tokenId].uri = uri;
        tokenMetadata.set(_tokenMetadata);


        uriRequest(tokenAddress,tokenId);

        // console.log(metadata);
        // _tokenMetadata[tokenAddress].tokens[tokenId].name        = metadata.name;
        // _tokenMetadata[tokenAddress].tokens[tokenId].description = metadata.description;
        // _tokenMetadata[tokenAddress].tokens[tokenId].image       = metadata.image;
        // tokenMetadata.set(_tokenMetadata);
    }catch(e){
        console.log('metadata fail');
        console.log(e);
        _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";
    }

    // if(dropTokenMetadataQueue[0] === queueItem){
    //     dropTokenMetadataQueue.splice(0,1);
    //     fetchDropTokenMetadata();
    // }

}
function decode_utf8(s) {
    return decodeURIComponent(escape(s));
}
async function uriRequest(tokenAddress,tokenId){
    let queueItem = JSON.stringify([tokenAddress,tokenId]);
    let uri = _tokenMetadata[tokenAddress].tokens[tokenId].uri;

    // console.log(uri);

    const binary_lead = "data:application/json;base64,";

    if(uri.substr(0,binary_lead.length) === binary_lead){

        try{
            let metadata = JSON.parse(window.atob(uri.substr(binary_lead.length)));

            _tokenMetadata[tokenAddress].tokens[tokenId].name        = decode_utf8(metadata.name);
            _tokenMetadata[tokenAddress].tokens[tokenId].description = decode_utf8(metadata.description);
            _tokenMetadata[tokenAddress].tokens[tokenId].image       = metadata.image;

            _tokenMetadata[tokenAddress].tokens[tokenId].state = "loaded";

            tokenMetadata.set(_tokenMetadata);

            if(dropTokenMetadataQueue[0] === queueItem){
                dropTokenMetadataQueue.splice(0,1);
                fetchDropTokenMetadata();
            }

        }catch(e){
            console.log(e);

            _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";

            if(dropTokenMetadataQueue[0] === queueItem){
                dropTokenMetadataQueue.splice(0,1);
                fetchDropTokenMetadata();
            }
        }
        return;
    }


    const cors_sidestep = "https://xv4jmp4cff.execute-api.ap-southeast-2.amazonaws.com/live?url="

    var request = new XMLHttpRequest();
    request.open('GET', cors_sidestep+uri, true);  // `false` makes the request synchronous
    // request.withCredentials = true;
    request.send();

    request.onerror = function(err) {
        _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";
        tokenMetadata.set(_tokenMetadata);

        if(dropTokenMetadataQueue[0] === queueItem){
            dropTokenMetadataQueue.splice(0,1);
            fetchDropTokenMetadata();
        }
    }
    request.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            try{
                let metadata = JSON.parse(request.responseText);

                _tokenMetadata[tokenAddress].tokens[tokenId].name        = metadata.name;
                _tokenMetadata[tokenAddress].tokens[tokenId].description = metadata.description;
                _tokenMetadata[tokenAddress].tokens[tokenId].image       = metadata.image;

                _tokenMetadata[tokenAddress].tokens[tokenId].state = "loaded";
            }catch(e){
                _tokenMetadata[tokenAddress].tokens[tokenId].state = "fail";
            }
            tokenMetadata.set(_tokenMetadata);

            if(dropTokenMetadataQueue[0] === queueItem){
                dropTokenMetadataQueue.splice(0,1);
                fetchDropTokenMetadata();
            }
        }
    }
}

function triggerInitialMetadata(){
    for(let address in _drops){
        requestDropContractMetadata(address);
        for(let tokenId in _drops[address]){
            requestDropTokenMetadata(address,tokenId);
        }
    }
}


async function unlockCallback(){
    if(!get(correct_network)){
        state.set("network");
    }else{
        await connect();
    }

    onWalletChange(async (correctNetwork)=>{
        console.log("WALLET CHANGE, RESET!");
        reset();
        if(!correctNetwork){
            state.set("network");
        } else{
            await connect();
        }
    });
}

export default async function init() {
    if(typeof window.ethereum === "undefined"){
        console.log('not injected')
        return;
    }
    console.log('injected')

    onUnlocked(unlockCallback);

    await unlock();
}


init();